import React, { FC } from 'react'
import { range, find } from 'lodash'
import { plural, t } from '@lingui/macro'

import Select from '../../../components/common/select/Select'

export const SelectMonthsOfValidity: FC<{
  value: number | null | undefined
  onChange: (x: number) => void
  disabled?: boolean
}> = ({ value, onChange, disabled }) => {
  const options: Array<null | number> = [null]
  const monthsStart = 1
  const monthsEnd = 37
  const monthsOfValidityOptions =
    options.concat(range(monthsStart, monthsEnd)).map((date) => ({
      label: date
        ? `${plural(date, {
            one: '# month',
            other: '# months'
          })}`
        : t`Not selected`,
      value: date
    })) || []

  return (
    <Select
      isDisabled={disabled}
      value={find(monthsOfValidityOptions, (option) => option.value === value)}
      options={monthsOfValidityOptions}
      onChange={(value) => value && onChange(value.value)}
    />
  )
}
